import {
    GET_PAY_OUT_STATUS_DEF_SUCCESS,
    PAY_OUT_STATUS_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const payOutStatusDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_PAY_OUT_STATUS_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case PAY_OUT_STATUS_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default payOutStatusDef